"use client";
import { useUiControlLabels } from "@/components/i18n/ui-control-labels-context"


import { Card, CardContent } from "@/components/ui/card";
import {
  Mail,
  Send,
  FileEdit,
  Users,
  TrendingUp,
  TrendingDown,
} from "lucide-react";
import type { KpiCard } from "../types";
import { useTranslations } from "next-intl"


const KPI_ICONS = [Mail, Send, FileEdit, Users];

interface OverviewCardsProps {
  cards: KpiCard[];
}

export function OverviewCards({ cards }: OverviewCardsProps) {
  const {locale: uiFormattingLocale} = useUiControlLabels()

  const tUi = useTranslations("Email.AgentsEmailAnalyticsSectionsOverviewCards")

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4">
      {cards.map((card, idx) => {
        const Icon = KPI_ICONS[idx] ?? Mail;
        const isPositiveTrend = card.trend > 0;
        const TrendIcon = isPositiveTrend ? TrendingUp : TrendingDown;
        // For human escalations a downward trend is good
        const isGoodTrend = idx === 3 ? !isPositiveTrend : isPositiveTrend;

        return (
          <Card key={card.label}>
            <CardContent className="p-4 lg:p-5">
              <div className="mb-3 flex items-center justify-between">
                <div className="p-2 rounded-lg bg-blue-50">
                  <Icon className="w-5 h-5 text-blue-600" />
                </div>
                {card.trend !== 0 && (
                  <div
                    className={`flex items-center gap-1 text-xs font-medium ${
                      isGoodTrend ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    <TrendIcon className="w-3.5 h-3.5" />
                    <span>{<span key={tUi("value0", { value0: String(Math.abs(card.trend)) })}>{tUi("value0", { value0: String(Math.abs(card.trend)) })}</span>}</span>
                  </div>
                )}
              </div>
              <div className="text-2xl font-bold text-foreground">
                {card.value.toLocaleString(uiFormattingLocale)}
              </div>
              <div className="mt-1 flex items-center justify-between gap-2">
                <span className="text-xs text-muted-foreground lg:text-sm">
                  {card.label}
                </span>
                {idx > 0 && (
                  <span className="text-xs text-muted-foreground">
                    {card.pct}%
                  </span>
                )}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
